import { takeEvery, call, put } from 'redux-saga/effects';
import {
    fetchActivityLogsStart,
    fetchActivityLogsSuccess,
    fetchActivityLogsFail,
    fetchUserActivityLogsStart,
    fetchUserActivityLogsSuccess,
    fetchUserActivityLogsFail,
    fetchAuditLogsStart,
    fetchAuditLogsSuccess,
    fetchAuditLogsFail,
    fetchFilteredAuditLogsStart,
    fetchFilteredAuditLogsSuccess,
    fetchFilteredAuditLogsFail,
} from '../slices/logsSlice';
import { getRequest } from '../../network';
import { activityLogs, userActivityLogs, auditLogs, auditLogsByAction } from '../apis';

// Generic handler for Logs API calls
function* fetchLogsSaga(action) {
    const { endpoint, successAction, failAction } = action.payload;

    try {
        const response = yield call(getRequest, endpoint);
        yield put(successAction(response));
    } catch (error) {
        yield put(failAction(error.message));
    }
}

// Individual sagas
function* fetchActivityLogsSaga() {
    yield fetchLogsSaga({
        payload: {
            endpoint: activityLogs,
            successAction: fetchActivityLogsSuccess,
            failAction: fetchActivityLogsFail,
        },
    });
}

function* fetchUserActivityLogsSaga(action) {
    yield fetchLogsSaga({
        payload: {
            endpoint: userActivityLogs.replace(':userId', action.payload.userId),
            successAction: fetchUserActivityLogsSuccess,
            failAction: fetchUserActivityLogsFail,
        },
    });
}

function* fetchAuditLogsSaga() {
    yield fetchLogsSaga({
        payload: {
            endpoint: auditLogs,
            successAction: fetchAuditLogsSuccess,
            failAction: fetchAuditLogsFail,
        },
    });
}

function* fetchFilteredAuditLogsSaga(action) {
    yield fetchLogsSaga({
        payload: {
            endpoint: auditLogsByAction.replace(':actionType', action.payload.actionType),
            successAction: fetchFilteredAuditLogsSuccess,
            failAction: fetchFilteredAuditLogsFail,
        },
    });
}

// Watcher saga
export function* watchLogs() {
    yield takeEvery(fetchActivityLogsStart.type, fetchActivityLogsSaga);
    yield takeEvery(fetchUserActivityLogsStart.type, fetchUserActivityLogsSaga);
    yield takeEvery(fetchAuditLogsStart.type, fetchAuditLogsSaga);
    yield takeEvery(fetchFilteredAuditLogsStart.type, fetchFilteredAuditLogsSaga);
}